import { api } from './index';

const FundsRequestService = {
    getTotal (params) {
        return api.get('funds/total/',params);
    },
    getTotalCollected(params) {
        return api.get('/funds/total-collected', params);
    },
    getInfoScancash(fiscal_year, company_id=null){
        return api.get('funds/get-info-scancash',{params:{fiscal_year,company_id}})
    },
    getInfoInnovation(fiscal_year, company_id=null){
        return api.get('funds/get-info-innovation',{params:{fiscal_year,company_id}})
    },
    getInfoElitePass(fiscal_year, company_id=null){
        return api.get('funds/get-info-elite-pass',{params:{fiscal_year,company_id}})
    },
    getInfoScansourceSelect(fiscal_year, company_id=null){
        return api.get('funds/get-info-scansource-select',{params:{fiscal_year,company_id}})
    },
    getDetail(year_id, company_id, type_id, params){
        return api.get('funds/detail',{params:{year_id, company_id, type_id, ...params}})
    },
    getDetailSummary(year_id, company_id, type_id){
        return api.get('funds/detail-summary',{params:{year_id, company_id, type_id}})
    },
    getPayments(token, year_id, company_id, status, page = 0){
        return api.get('funds/payments',{params:{year_id, company_id, status, page}, cancelToken: token})
    },
    getRescues(token, year_id, company_id, status, page = 0){
        return api.get('funds/rescues',{params:{year_id, company_id, status, page}, cancelToken: token})
    }
};

export default FundsRequestService;